import React from 'react';
import { connect } from 'react-redux';
import { signOut, requestLocationChange, getCurrentUser } from '../actions';

import Router, { hasAccess } from '../containers/Router';
import ErrorSnackBar from '../containers/ErrorSnackBar';

// Material UI Modules
import AppBar from 'material-ui/AppBar';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MdMore from 'react-icons/lib/md/more-vert';
import MdChevronLeft from 'react-icons/lib/md/chevron-left';

function handleSignOut(props) {
  props.signOutUser();
};

function hamburger(props) {
  if (!props.currentUser.get('id')) return <span></span>;
  return (
    <IconMenu
      iconButtonElement={<IconButton><MdMore fill="white" width="24" height="24" /></IconButton>}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      <MenuItem
        primaryText="Sign out"
        onTouchTap={handleSignOut.bind(this, props)}
      />
    </IconMenu>
  );
}

function backElement(props) {
  const previousName = locationNameMap(props).previous;
  if (previousName && hasAccess(props.currentUser, previousName)) {
    return (
      <IconButton onTouchTap={props.handleBackNavigation.bind(this, props)}>
        <MdChevronLeft fill="white" width="24" height="24" />
      </IconButton>
    );
  }
}

function locationNameMap(props) {
  const map = {
    userIndex: {
      name: 'Manage Users',
      previous: 'home',
    },
    userDetail: {
      name: 'User',
      previous: 'home',
    },
    userEdit: {
      name: 'Edit User',
      previous: 'home',
    },
    login: {
      name: 'Sign In',
      previous: false,
    },
    home: {
      name: 'Home',
      previous: false,
    },
    search: {
      name: 'Browse Cards',
      previous: 'home',
    },
    newCollective: {
      name: 'New Collective',
      previous: 'home',
    },
    newInfluencer: {
      name: 'New Individual',
      previous: 'home',
    },
    viewCollective: {
      name: 'View Collective',
      previous: 'search',
    },
    collectiveViewInfluencer: {
      name: 'View Influencer',
      previous: 'viewCollective',
      options: { id: props.location.get('options').get('collectiveId') },
    },
    influencerViewCollective: {
      name: 'View Collective',
      previous: 'viewInfluencer',
      options: { id: props.location.get('options').get('influencerId') },
    },
    viewInfluencer: {
      name: 'View Individual',
      previous: 'search',
    },
    editCollective: {
      name: 'Edit Collective',
      previous: 'search',
    },
    editCollectiveImport: {
      name: 'Edit Collective',
      previous: 'importInfluencers',
    },
    editInfluencer: {
      name: 'Edit Individual',
      previous: 'search',
    },
    importInfluencers: {
      name: 'Import Tool',
      previous: 'home',
    },
  };

  return map[props.location.get('name')] || {};
}

function App(props) {
  const currentLocation = locationNameMap(props);
  if (props.location.get('name') &&
      props.location.get('name') !== 'login' &&
      props.currentUser.size === 0
    ) {
    if (props.currentUser.get('isFetching')) return;
    console.log('location name', props.location.get('name'))
    props.fetchCurrentUser();
  }

  return (
   <div className="full-height">
     <AppBar
       title={currentLocation.name}
       showMenuIconButton={!!currentLocation.previous}
       iconElementLeft={backElement(props)}
       iconElementRight={hamburger(props)}
     >
     </AppBar>
     <Router />
     <ErrorSnackBar />
   </div>
  );
};

function mapStateToProps(state) {
  return {
    location: state.get('location'),
    currentUser: state.get('currentUser'),
  };
}

function mapDispatchToProps(dispatch) {
  return {

    fetchCurrentUser: function () {
      dispatch(getCurrentUser());
    },

    signOutUser: function () {
      dispatch(signOut());
    },

    handleBackNavigation: function (props) {
      const currentLocation = locationNameMap(props);
      dispatch(requestLocationChange(currentLocation.previous, currentLocation.options));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./components/App.js
 **/